import styled from 'styled-components';

// Esta página vive bajo ReportingLayout, NO bajo el layout del módulo RV, así
// que no puede reusar el `Container` de `../components/MainStyledComponents`
// (ese es para las pantallas a ancho completo del RV: detalle y asistente).
//
// ReportingLayout monta una fila flex con el menú de Informes a la izquierda
// (`NavContainer` con `min-width: 36rem`) y un `gap: 4rem` — 40rem en total que
// la página NO tiene disponibles. Con `width: 100%` la página pedía toda la
// fila y se salía por la derecha exactamente esos 40rem, más los 6.4rem de
// padding lateral que el contenedor del módulo RV añade y los otros listados
// no tienen. Solo se nota por encima del breakpoint smallDesktop: por debajo,
// ReportingLayout apila el menú en columna y el ancho completo sí es correcto.
//
// Copia del patrón canónico de los otros listados históricos
// (workOrders / budgets / comunications `components/MainStyledComponents`).
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(100% - 40rem);
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 3.98rem;
  gap: 1.6rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    margin-top: ${({ theme }) => theme.spaces.s}rem;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    margin-top: ${({ theme }) => theme.spaces.l}rem;
    justify-content: center;
  }
`;
